import { render } from "./programmeManagement.vue?vue&type=template&id=0074e912&scoped=true"
import script from "./programmeManagement.vue?vue&type=script&lang=js"
export * from "./programmeManagement.vue?vue&type=script&lang=js"

import "./programmeManagement.vue?vue&type=style&index=0&id=0074e912&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0074e912"

export default script